import type { ReactNode } from "react";

export default function Container({
  children,
  className = "",
  variant = "default",
}: {
  children: ReactNode;
  className?: string;
  variant?: "default" | "wide";
}) {
  const base = "mx-auto w-full px-4 sm:px-6 lg:px-8";
  const width =
    variant === "wide" ? "max-w-[96rem]" : "max-w-7xl"; // wide ≈ 1536px

  return <div className={`${base} ${width} ${className}`}>{children}</div>;
}
